import type { ExchangeRateQueryPort } from "../../../application/ports/ExchangeRateQueryPort";

interface ExchangeRateHttpAdapterConfig {
  baseUrl: string;
}

export class ExchangeRateHttpAdapter implements ExchangeRateQueryPort {
  constructor(private readonly config: ExchangeRateHttpAdapterConfig) {}

  async getUsdRate(): Promise<number> {
    const response = await fetch(this.config.baseUrl);

    if (!response.ok) {
      throw new Error("No fue posible obtener la tasa de cambio");
    }

    const payload = (await response.json()) as { current?: { usd?: number } };
    const rate = payload.current?.usd;

    if (typeof rate !== "number" || Number.isNaN(rate)) {
      throw new Error("Tasa de cambio inválida");
    }

    return rate;
  }
}
